// @flow
import * as React from 'react';
import styled from 'styled-components';
import Advertiser from 'common/modules/advertiser/domain/Advertiser';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Text = styled.div`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export default function AdvertiserCard({ advertiser }: { advertiser: Advertiser }) {
  return (
    <Wrapper>
      <Text>{advertiser.name}</Text>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/advertisers/modules/advertiser/components/AdvertiserCard.js